<template>
    <button
        @click.prevent="logout"
        class="inline-flex items-center justify-start md:justify-center px-4 py-2 rounded font-semibold text-left text-gray-800 tracking-wide hover:bg-gray-200 "
    >
        <span class="md:hidden">Logout</span>
        <icon type="logout" class="hidden md:inline-block w-6 h-6"/>
    </button>
</template>

<script>
import useForm from '@/functions/useForm'

export default {
    data() {
        return {
            form: useForm(),
        }
    },
    methods: {
        logout() {
            this.form.post('/logout')
        }
    }
}
</script>
